export default {
  acronyms: ["ltd", 'sprl', 'sa', 'srl', 'asbl', 'scrl'],
  fullName(surname, lastname) {
      return [this.ucfirst(lastname), this.ucfirst(surname)].filter(x => x).join(", ");
  },
  company(str) {
    if(!str) return '';
    return this.ucfirst(str, true);
  },
  ucfirst(str, acronyms = false) {
    if(!str) return '';
    const regex = /([A-Za-zA-Úa-ù]*)/gmu;
    return str.replace(regex, (x) => { 
      if(acronyms && this.acronyms.includes(x.toLowerCase())) {
        return '<i>' + x.toUpperCase() + '</i>';
      }

      return (x.charAt(0).toUpperCase() + x.substring(1).toLowerCase());
    }); 
  }
}